import { connect } from 'react-redux';
import HomeView from './index'
import {loadEvents} from '../../actions/Events'
import {loadStreamings} from '../../actions/Streamings'
import {serverUrl} from '../../utils/restUtils'
import moment from 'moment'

const mapStateToProps = (state, props) => {

    
    return {
	slideshowPages: state.pages.list ? state.pages.list.filter((e) => e.is_main).map((x) => {x.image = x.image_id ? serverUrl()+'/images/'+x.image_id : '/images/noimage.png'
									x.link = '/pages/'+x.title
						     return x
								       }) : null,
	events: state.events.list ? state.events.list.filter((e) => e.is_main) : null,
	streamings: state.streamings.list != null ? state.streamings.list.filter(s => moment(s.date_to).isAfter())  : []
	
    }
}

const mapDispatchToProps = (dispatch, state) => {
    return {
	loadEvents: () => {
	    return dispatch(loadEvents());
	},
	loadStreamings: () => {
	    return dispatch(loadStreamings());
	}
    }
  
}

const HomeContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(HomeView);




export default HomeContainer;



// WEBPACK FOOTER //
// ./src/components/Home/Container.js